import { Component, HostListener, OnInit, ViewChild } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ModalDialogComponent } from 'src/app/shared/modal-dialog/modal-dialog.component'
import { HubspotService } from 'src/app/services/hubspot.service'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { handleArpioError } from 'src/utils/handle-error'
import { ApiService } from 'src/app/services/api.service'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false,
})
export class SupportComponent implements OnInit {
  @ViewChild('submitTicketDialog', { static: true }) submitTicketDialog: ModalDialogComponent
  @ViewChild('confirmTicketDialog', { static: true }) confirmTicketDialog: ModalDialogComponent

  backupNumberVisible = false
  openTicketSubscription: Subscription = null
  hubspotResponse: string = null

  createTicketFormModel: UntypedFormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    ticketPriority: ['Low', [Validators.required]],
    ticketSubject: ['', [Validators.required]],
    ticketContent: ['', [Validators.required]],
  })
  constructor(
    public uiService: UiService,
    public apiService: ApiService,
    private hubspotService: HubspotService,
    private formBuilder: UntypedFormBuilder
  ) {}

  showTicketForm() {
    this.submitTicketDialog.open()
  }

  hideTicketForm() {
    this.submitTicketDialog.close()
  }

  // Esc closes whichever support modal is open. Confirm dialog is dismissed
  // first because it opens on top of (and after) the submit dialog. Guarded on
  // `openingTicket` so an accidental Esc can't tear down the form mid-submit.
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent): void {
    if (this.confirmTicketDialog?.isOpen) {
      event.preventDefault()
      this.confirmTicketDialog.close()
      return
    }
    if (this.submitTicketDialog?.isOpen) {
      if (this.openingTicket) return
      event.preventDefault()
      this.hideTicketForm()
    }
  }

  ngOnInit(): void {}

  openTicket(): void {
    this.openTicketSubscription = this.hubspotService
      .openTicket$(this.createTicketFormModel.value)
      .pipe(
        finalize(() => {
          this.openTicketSubscription = null
          this.hideTicketForm()
        })
      )
      .subscribe(
        (hsResponse) => {
          this.hubspotResponse = hsResponse.inlineMessage
          this.confirmTicketDialog.open()
        },
        handleArpioError(window.location.href, this.apiService, this.uiService)
      )
  }

  get supportNumber(): string {
    return '+1 844-664-1882'
  }

  get backupNumber(): string {
    return '+1 919-229-9362'
  }

  showBackupNumber() {
    this.backupNumberVisible = true
  }

  get openingTicket(): boolean {
    return subscriptionActive(this.openTicketSubscription)
  }
}
